<template>
  <div>
    <can I="update" a="blueprints">
      <v-container fluid>
        <v-row wrap>
          <v-col v-if="!blueprintPage" lg="6" xs="12" sm="12" class="d-flex child-flex" cols="12">
            <!-- <v-responsive aspect-ratio="1"> -->
            <v-card
              :disabled="$store.state.isOffline"
              outlined
              height="350px"
              v-ripple
              class="text-center justify-center d-flex pa-5 body-1 font-weight-light"
              @click="noBlueprint"
            >
              <div class="d-flex justify-center">
                <div class="my-auto">
                  <v-icon x-large color="primary">grid_off</v-icon>
                  <div>{{$t("noBlueprint")}}</div>
                </div>
              </div>
            </v-card>
            <!-- </v-responsive> -->
          </v-col>

          <v-col :lg="blueprintPage ? '12' : 6" xs="12" sm="12" class cols="12">
            <label :for="loading ? '':'file'" class="flex-fill" slot="upload-label">
              <v-card
                :disabled="readonly || $store.state.isOffline"
                outlined
                style="cursor: pointer"
                height="350px"
                v-ripple
                class="text-center pa-5 body-1 font-weight-light"
              >
                <v-form class="center" ref="form" lazy-validation>
                  <div class="text-center">
                    <!-- <image-uploader
                      class="eieie"
                      :preview="true"
                      :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                      :debug="1"
                      id="file"
                      :quality="0.8"
                      accept=".jpg, .png, application/pdf"
                      outputFormat="verbose"
                      @input="setImage"
                    ></image-uploader>
                    <div>
                      <v-icon color="primary" large v-if="!image">add_photo_alternate</v-icon>
                      <v-icon color="primary" v-else large>redo</v-icon>
                      <div>{{$t("uploadBlueprintFile")}}</div>
                    </div>-->
                    <v-icon color="primary" large>add_photo_alternate</v-icon>
                    <input
                      v-if="uploadReady"
                      @change="onFileChanged"
                      :accept="$can('upload','pdf') ? '.jpg, .png, .pdf' : '.jpg, .png,'"
                      style="display:none"
                      type="file"
                      ref="file"
                      id="file"
                    />
                    <div>
                    <v-badge
                      :value="$can('upload','pdf') ? 0 : '.pdf Pro/Expert license'"
                      :content="$can('upload','pdf') ? 0 : '.pdf Pro/Expert license'"
                      
                    >
                      <div>{{$t("uploadBlueprintFile")}}</div>
                    </v-badge>
                    </div>
                  </div>
                </v-form>
              </v-card>
            </label>
            <!-- <label style="cursor: pointer" for="file">
              <v-icon v-ripple>attach_file</v-icon>
              {{file != null ? file.name : $t('chooseFile')}}
            </label>
            <input @change="onFileChanged" style="display:none" type="file" ref="file" id="file" />-->
            <!-- <v-sheet height="350px" class="text-center pa-5 body-1 font-weight-light d-flex">
               <v-btn
                      :disabled="image == null ? true: false || readonly || $store.state.isOffline"
                      class="mx-auto my-auto d-flex"
                      color="primary"
                      depressed
                      x-large
                      @click="onUpload"
            >{{$t("uploadBlueprintImage")}}</v-btn>
            </v-sheet>-->
          </v-col>
        </v-row>
      </v-container>
    </can>
    <v-dialog v-model="showPageSelector" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('selectYourPage')}}</v-card-title>

        <v-card-text>
          <v-text-field type="telephone" v-model="page" filled></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="close">{{$t('cancel')}}</v-btn>

          <v-btn
            color="secondary"
            depressed
            @click="showPageSelector = false;uploadFile()"
          >{{$t('upload')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loadingDialog :dialog="loading"></loadingDialog>
  </div>
</template>

<script>
import uploadButton from "vuetify-upload-button";

export default {
  name: "uploadBlueprint",
  props: {
    blueprintPage: Boolean,
    readonly: Boolean,
    blueprintId: String
  },
  data() {
    return {
      // selectedFile: null,
      hasImage: false,
      image: null,
      loading: false,
      showPageSelector: false,
      page: 1,
      uploadReady: true,
    };
  },
  components: {
    uploadButton,
  },
  methods: {
    setImage: function (output, e) {
      console.log(output, e);
      if (output.type === "application/pdf") {
        this.uploadPdf(output);
      } else {
        this.hasImage = true;
        this.image = output;
        this.onUpload();
      }
    },
    close() {
      this.showPageSelector = false;
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
    },
    noBlueprint() {
      this.loading = true;

      let formData = new FormData();
      formData.append("blueprintId", this.blueprintId);
      this.$http
        .addBlueprintFile(formData)
        .then((res) => {
          this.loading = false;
          this.$router.go();
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$noty.error(err);
        });
    },
    uploadFile() {
      this.loading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("blueprintId",this.blueprintId);
      formData.append("page", this.page);
      this.$http
        .addBlueprintFile(formData)
        .then((res) => {
          this.$router.go();
        })
        .catch((err) => {
          this.uploadReady = false;
          this.$nextTick(() => {
            this.uploadReady = true;
          });
          console.log(err);
          this.loading = false;
          this.$noty.error(err);
        });
    },
    onFileChanged(event) {
      if (!event.target.files.length) return;
      this.file = event.target.files[0];
      if (this.file.type === "application/pdf") {
        this.showPageSelector = true;
      } else {
        this.uploadFile();
      }
    },
    onUpload() {
      if (this.hasImage) {
        let formData = new FormData();
        formData.append("file", this.image);
        formData.append("blueprintId", this.blueprintId);
        this.$http
          .addBlueprintFile(formData)
          .then((res) => {
            this.loading = false;
            this.$router.go();
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.$noty.error(err);
          });
      }

      // this.$http.addBlueprintFile(this.$route.params.id, formData).then(res => {
      //   //
      // });
    },
  },
};
</script>

<style>
#file {
  display: none;
}
.center {
  position: relative;
  top: 50%;
  left: 50;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.img-preview {
  height: 250px !important;
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Blueprints/UploadBlueprint.vue